import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import '../../App.css';
import '../create-json/CreateJson.css';
import '../default-configuration/DefaultConfiguration.css';
import {Button, MenuItem, Select} from "@mui/material";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import useAxiosPrivate from "../../context/useAxiosPrivate";

export const DefaultConfiguration = () => {
  const navigate = useNavigate();
  const [factories, setFactories] = useState(null);
  const [currentFactory, setCurrentFactory] = useState('');
  const [factoriesSelectOptions, setFactoriesSelectOptions] = useState('');
  const [defaultMaterialData, setDefaultMaterialData] = useState('');
  const [defaultMenuData, setDefaultMenuData] = useState('');
  const [defaultBundleInfoData, setDefaultBundleInfoData] = useState('');
  const axiosPrivate = useAxiosPrivate();


    useEffect(() => {
    getFactories();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
    if (factories !== null) {
      getFactoriesSelectOptions()
    }

  }, [factories]); // eslint-disable-line react-hooks/exhaustive-deps


  const getFactories = async () => {
    await axiosPrivate.get('/Users/Factory')
      .then((res) => {
        setFactories(res.data);
      })
      .catch( (e) => { console.log("getFactories error ", e) } );
  }

    const [configurations, setConfigurations] = useState([]);
  const [loadingConfigurations, setLoadingConfigurations] = useState(false);

    useEffect(() => {
    if (currentFactory) {
      getDefaultConfigurations();
    }
  }, [currentFactory]); // eslint-disable-line react-hooks/exhaustive-deps

  const getDefaultConfigurations = async () => {
    if (!currentFactory) return;
    
    setLoadingConfigurations(true);
    axiosPrivate.get(`/UserAdministration/GetDefaultConfigurations/${currentFactory}`)
      .then((res) => {
        const data = res.data;
        setConfigurations(Array.isArray(data) ? data : []);
        setDefaultMaterialData('');
        setDefaultMenuData('');
        setDefaultBundleInfoData('');
      })
      .catch(e => {
        setConfigurations([]);
        setDefaultMaterialData('');
        setDefaultMenuData('');
        setDefaultBundleInfoData('');
        console.log("getDefaultConfigurations error ", e);
        if (e.response?.data?.message) {
          alert(e.response.data.message);
        }
      })
      .finally(() => {
        setLoadingConfigurations(false);
      });
  };

    const transferDefaultConfiguration = () => {
    if (!defaultMaterialData && !defaultMenuData && !defaultBundleInfoData) {
      alert("Заполните хотя бы одно поле (Material, Menu или Bundle Info)");
      return;
    }

    const transferData = {
      factoryId: JSON.parse(currentFactory)
    };

    if (defaultMaterialData) {
      try {
        transferData.material = JSON.parse(defaultMaterialData);
      } catch (e) {
        alert("Ошибка в JSON поля Material");
        return;
      }
    }
    if (defaultMenuData) {
      try {
        transferData.menu = JSON.parse(defaultMenuData);
      } catch (e) {
        alert("Ошибка в JSON поля Menu");
        return;
      }
    }
    if (defaultBundleInfoData) {
      try {
        transferData.bundleInfo = JSON.parse(defaultBundleInfoData);
      } catch (e) {
        alert("Ошибка в JSON поля Bundle Info");
        return;
      }
    }

    axiosPrivate.post(`/UserAdministration/DefaultConfiguration`, transferData)
      .then((res) => {
        alert("Конфигурация добавлена");
        setDefaultMaterialData('');
        setDefaultMenuData('');
        setDefaultBundleInfoData('');
        getDefaultConfigurations();
      })
      .catch(e => {
        alert(JSON.stringify(e.response?.data?.message || e.message));
      });
  }

  const loadConfigurationToForm = (config) => {
    setDefaultMaterialData(config.material ? JSON.stringify(config.material, null, 2) : '');
    setDefaultMenuData(config.menu ? JSON.stringify(config.menu, null, 2) : '');
    setDefaultBundleInfoData(config.bundleInfo ? JSON.stringify(config.bundleInfo, null, 2) : '');
  }

  const getFactoriesSelectOptions = () => {
    const optionData = factories.map((factory) => {
      return <MenuItem key={factory.id} value={factory.id}>{`${factory.factory}`}</MenuItem>
    })
    setFactoriesSelectOptions(optionData); // form list of factories in dropdown menu
    setCurrentFactory(factories[0].id)
  }
  return (
    <>
      <div className="default-config">
        <div className="default-config__textarea-box">
                    <label htmlFor="textarea-material">MATERIAL (новые данные)</label>
          <textarea
            wrap="soft"
            id="textarea-material"
            className="default-config__textarea"
            placeholder='Введите JSON для Material или нажмите на существующую конфигурацию справа'
            value={defaultMaterialData}
            onChange={(e) => setDefaultMaterialData(e.target.value)}
          ></textarea>

          <label htmlFor="textarea-menu">MENU (новые данные)</label>
          <textarea
            wrap="soft"
            id="textarea-menu"
            className="default-config__textarea"
            placeholder='Введите JSON для Menu или нажмите на существующую конфигурацию справа'
            value={defaultMenuData}
            onChange={(e) => setDefaultMenuData(e.target.value)}
          ></textarea>

          <label htmlFor="textarea-bundle-info">BUNDLE INFO (новые данные)</label>
          <textarea
            wrap="soft"
            id="textarea-bundle-info"
            className="default-config__textarea"
            placeholder='Введите JSON для Bundle Info или нажмите на существующую конфигурацию справа'
            value={defaultBundleInfoData}
            onChange={(e) => setDefaultBundleInfoData(e.target.value)}
          ></textarea>
        </div>

        <div className="default-config__controls">
          <div className="select-container">
            <Select
              IconComponent={ExpandMoreOutlinedIcon}
              style={{backgroundColor: "white", width: "100%"}}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left"
                },
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root': {fontSize: "1vw"}
                  }
                }
              }}
              sx={{
                '& .MuiInputBase-root': {borderRadius: "8px", border: "0.2vw solid grey", outline: "none"},
                '& .MuiSelect-select': {
                  backgroundColor: "white",
                  border: "none",
                  width: "100%",
                  fontSize: "1vw",
                  minHeight: "2vw",
                  lineHeight: "1",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  overflow: "hidden",
                },
                '& .MuiInputBase-input': {padding: "0 3vw 0 0.5vw !important", width: "4vw"},
                '& .MuiSvgIcon-root': {position: "absolute", top: "calc(50% - 1.5vw)", right: "0", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "3vw", backgroundColor: "white"},

              }}
              variant={"outlined"}
              autoWidth={true}
              value={currentFactory}
              onChange={(event) => {
                setCurrentFactory(event.target.value);
                }
              }
            >
              {factoriesSelectOptions}
            </Select>
          </div>

                    {/* Список существующих конфигураций */}
          <div className="default-config__configurations-list">
            <h4>Существующие конфигурации:</h4>
            {loadingConfigurations ? (
              <p>Загрузка...</p>
            ) : configurations.length > 0 ? (
              <ul>
                {configurations.map((config, index) => (
                  <li 
                    key={config.id || index} 
                    onClick={() => loadConfigurationToForm(config)}
                    className="default-config__config-item"
                    title="Нажмите чтобы просмотреть данные конфигурации"
                  >
                    <span>Конфигурация #{index + 1}</span>
                    {config.id && <span className="config-id"> (ID: {config.id})</span>}
                  </li>
                ))}
              </ul>
            ) : (
              <p>Нет конфигураций для этого завода</p>
            )}
          </div>

          <div className="default-config__button-group">
            <Button
              className='save-button'
              variant="outlined"
              onClick={() => getDefaultConfigurations()}
            >
              {"Обновить список конфигураций"}
            </Button>

            <Button
              className='save-button'
              variant="outlined"
              onClick={() => transferDefaultConfiguration()}
            >
              {"Добавить новую конфигурацию"}
            </Button>
          </div>


          <div className="default-config__button-group">
            <Button
              className='save-button'
              variant="outlined"
              onClick={() => {navigate('/')}}
            >
              {"Вернуться на главную"}
            </Button>

            <Button
              className='save-button'
              variant="outlined"
              onClick={() => {navigate('/add-json')}}
            >
              {"Вернуться в конструктор"}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}